import { useMemo } from "react";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { getAuthItem } from "../../../public/utils/authStorage";
import { useChequeRolePermissions } from "../hooks/useChequeRolePermissions";
import {
  buildChequePermissions,
  buildChequePermissionsForScreen,
} from "./chequePermissions";

function resolveRoleSlug() {
  return (
    getJwtRoleSlug(getAuthItem("jwt_token")) ||
    getStoredAuthRole() ||
    ""
  );
}

/** Cheque permissions for a screen slug (cheque-issues). */
export function useChequeRole(screenSlug = null) {
  const sessionRoleSlug = useMemo(() => resolveRoleSlug(), []);

  const {
    permissions,
    roleSlug: apiRoleSlug,
    loading: permLoading,
    error: permissionsError,
  } = useChequeRolePermissions(Boolean(sessionRoleSlug));

  const roleSlug = apiRoleSlug || sessionRoleSlug;

  const perms = useMemo(() => {
    if (screenSlug) {
      return buildChequePermissionsForScreen(permissions, roleSlug, screenSlug);
    }
    return buildChequePermissions(permissions);
  }, [permissions, roleSlug, screenSlug]);

  return {
    roleSlug,
    permissionsLoading: permLoading,
    permissionsError,
    isAdmin: perms.isAdmin,
    canView: perms.canView,
    canCreate: perms.canCreate,
    canEdit: perms.canEdit,
    canDelete: perms.canDelete,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
  };
}
